/* istanbul ignore file */
import * as codec from 'purify-ts/Codec';
import { string as codecString } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const OptionParser = /* #__PURE__ */ parsers.object([
    ['name', codecString],
    ['default', codec.unknown],
    ['value', codec.unknown],
]);
export class Option extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return OptionParser.decode(input).map(res => new Option(res));
    }
    static unsafeDecode(input) {
        return Option.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return OptionParser.encode(data);
    }
    static schema() {
        return OptionParser.schema();
    }
}
